// extracted by mini-css-extract-plugin
export default {"pieChartWrapper":"PieChart_pieChartWrapper__Knzcs"};